import 'jquery-match-height';
import Swiper from 'swiper';

class SliderAccent {
    constructor(item) {
        this.sliderElement = item;
        this.speed = Number(this.sliderElement.dataset.speed) || 3000;
        // jquery caption elems for plugin
        this.$captions = $(this.sliderElement).find('.j-slider-accent-caption');

        this.slider = null;
        this.sliderNum = null;
    }

    init() {
        // На самом деле effect : 'fade' перевёрстан на translate
        this.slider = new Swiper(this.sliderElement, {
            init                  : false,
            wrapperClass          : 'j-slider-accent-wrapper',
            slideClass            : 'j-slider-accent-slide',
            slideActiveClass      : 'is-active',
            slidesPerView         : 'auto',
            containerModifierClass: 'is-',
            effect                : 'fade',
            slideToClickedSlide   : true,
            speed                 : 500,
            grabCursor            : true,
            autoplay              : {
                delay: this.speed
            },
            loop                : true,
            loopAdditionalSlides: 0,
            loopedSlides        : 0,
            navigation          : {
                prevEl       : '.j-accent-slider__prev',
                nextEl       : '.j-accent-slider__next',
                disabledClass: 'is-disabled'
            },
            pagination: {
                el            : '.j-accent-slider__counter',
                type          : 'fraction',
                renderFraction: function() { // eslint-disable-line
                    const realCount = this.slides.length - 2;

                    return `<span class="slider-accent__counter-current j-accent-slider-slide-num">
                        ${this.activeIndex}</span>/<span class="slider-accent__counter-total">${realCount}</span>`;
                }
            }
        });
        this._fixCaptions();
        this._bindEvents();

        this.slider.init();
        this.slider.autoplay.stop();
        this.sliderNum = this.sliderElement.querySelector('.j-accent-slider-slide-num');
    }

    _fixCaptions() {
        if (!this.$captions.length) {
            return;
        }

        this.$captions.matchHeight();
    }

    /**
     * Навешиваем события для слайдера
     * @private
     */
    _bindEvents() {
        this.slider.on('init', this._onInit.bind(this));
        this.slider.on('slideChange', this._onChange.bind(this));
        this.slider.on('autoplayStart', this._onAutoplayStart.bind(this));
        this.slider.on('autoplayStop', this._onAutoplayStop.bind(this));
        this.slider.on('slideChangeTransitionStart', this._onTransitionStart.bind(this));
        this.slider.on('slideChangeTransitionEnd', this._onTransitionEnd.bind(this));
    }

    _onInit() {
        this._fixLoop();
        setTimeout(() => {
            this.slider.wrapperEl.classList.add('is-ready');
            // запускаем автоплей
            this._startAutoplay();
        }, 0);
    }

    _fixLoop() {
        this._setTransform(this.slider.previousIndex);
    }

    /**
     * Запускает автоплей один раз для каждого слайдера, когда он появляется на экране
     * @private
     */
    _startAutoplay() {
        if ('IntersectionObserver' in window) {
            this.sliderObserver = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !this.slider.autoplay.running) {
                        this.slider.autoplay.start();
                        this.sliderObserver.unobserve(this.sliderElement);
                    }
                });
            }, {
                threshold: 0.75
            });

            this.sliderObserver.observe(this.sliderElement);
        } else {
            this.slider.autoplay.start();
        }
    }

    _onChange() {
        this._setTransform(this.slider.activeIndex);
        this._setSlideNumber();
        this._stopVideo();
    }

    _setTransform(index) {
        this._fixLastLoopTransform();

        const templateSlide = this.slider.slides[index];
        const templateSlideWidth = Number(window.getComputedStyle(templateSlide).getPropertyValue('width')
            .replace('px', ''));
        const templateSlideOffset = Number(window.getComputedStyle(templateSlide).getPropertyValue('margin-right')
            .replace('px', ''));
        const offset = templateSlideWidth + templateSlideOffset;

        this.slider.wrapperEl.style.transform = `translate(-${this.slider.activeIndex * offset}px)`;
    }

    _fixLastLoopTransform() {
        if (this.slider.previousIndex === this.slider.slides.length - 2 &&
            this.slider.activeIndex === this.slider.slides.length - 1) {
            this.slider.slideTo(1);
        }

        if (this.slider.previousIndex === 1 && this.slider.activeIndex === 0) {
            this.slider.slideTo(this.slider.slides.length - 2);
        }
    }

    _setSlideNumber() {
        if (this.sliderNum) {
            this.sliderNum.innerHTML = Number(this.slider.slides[this.slider.activeIndex].dataset.swiperSlideIndex) + 1;
        }
    }

    _stopVideo() {
        const iframe = this.slider.slides[this.slider.previousIndex].querySelector('iframe');

        if (!iframe) {
            return;
        }

        const iframeSrc = iframe.src;

        iframe.src = iframeSrc;
    }

    _onAutoplayStart() {
        this.slider.navigation.nextEl.classList.remove('is-animation-end');
    }

    _onAutoplayStop() {
        this.slider.navigation.nextEl.classList.add('is-animation-end');
    }

    _onTransitionStart() {
        if (!this.slider.autoplay.running) {
            return;
        }

        setTimeout(() => {
            this._onAutoplayStop();
        }, this.slider.params.speed / 2);
    }

    _onTransitionEnd() {
        if (!this.slider.autoplay.running) {
            return;
        }

        this._onAutoplayStart();
    }
}

export default SliderAccent;
